export enum LoadingState {
    loadingList = "loadingList",
    loadingAddUpdate = "loadingAddUpdate",
    loadingDelete = "loadingDelete",
    notLoading = "notLoading",
}
export type ApplicationStatus = "registered" | "completed" | "noShow" | "submitted" | "notRegistered" | "pending";
export type ExamStatus = 'notRegistered' | 'Pending' | 'Submitted' | 'Registered' | 'Withdrew' | 'Exempt';
export type SubExamType = 'in_person_msq_in_person_osce' | 'virtual_mcq_virtual_osce' | 'virtual_mcq_in_person_osce' | 'in_person_osce' | 'virtual_osce' | 'in_person_mcq' | 'virtual_mcq';
export type ExamType = 'IENCAP' | 'ARNAP' | 'IGOEE' | 'KCAT' | 'CELBAN' | 'ARTLABEXAM' | 'ALPNCE';
export type IExaminersType = 'Examiner' | 'Standardized-client' | 'All'
export type IRecruitMode = { name: IExaminersType, title: string }; 